/* eslint-disable react/prop-types */
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
// import { GOHONZON_SUBMISSION } from "../../contants/formFields";
// import InputField from "../common/new/InputField/InputField";
import Typography from "../common/new/Typography/Typography";
import styles from "./AppointMentBoolInput.styles";

function AppointMentBoolInput({
  name,
  value,
  preLabel,
  required,
  handleChange,
  readOnly,
  labelStyles,
  buttonLabels = ["Yes", "No"],
  lableValues = ["YES", "NO"],
}) {
  return (
    <Box style={styles.boolInputContainer}>
      <Box
        style={
          labelStyles || {
            ...styles.boolInputContainer,
            width: "50%",
            flex: "none",
          }
        }
      >
        <Typography
          variant="mini"
          color="#5e5e5e"
          weight={500}
          style={{ fontSize: "17px" }}
        >
          {preLabel}{" "}
          {required ? (
            <Typography variant="small" color="#FF6A69">
              *
            </Typography>
          ) : (
            ""
          )}
        </Typography>
      </Box>
      <Box style={{ ...styles.radioButtons }}>
        <FormControl
          style={{
            minWidth: "180px",
          }}
        >
          <RadioGroup
            row
            name={name}
            value={value}
            onChange={handleChange}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <FormControlLabel
              style={{
                width: "50%",
              }}
              value={lableValues[0]}
              control={
                <Radio
                  size="small"
                  disabled={readOnly}
                  // required={required}
                />
              }
              label={buttonLabels[0]}
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: 17,
                  fontWeight: 600,
                },
              }}
            />
            <FormControlLabel
              value={lableValues[1]}
              control={
                <Radio
                  size="small"
                  disabled={readOnly}
                  //  required={required}
                />
              }
              label={buttonLabels[1]}
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: 17,
                  fontWeight: 600,
                },
              }}
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
}

export default AppointMentBoolInput;
